class CustomerPortalAPI {
  constructor() {
	this.auth = window.ShopifyRequestAuth || {};
	this.customer = window.FMCustomer || {};

	if (!this.auth.shop || !this.auth.timestamp || !this.auth.hmac) {
	  console.error("Missing ShopifyRequestAuth values");
	}

	if (!this.customer.cisproAcctID) {
	  console.warn("Missing customer cisproAcctID");
	}
  }

  get headers() {
	return {
	  'X-Shopify-Shop': this.auth.shop,
	  'X-Shopify-Timestamp': this.auth.timestamp,
	  'X-Shopify-Hmac': this.auth.hmac,
	  'ngrok-skip-browser-warning': 'true',
	};
  }

  async fetchJSON(url, options = {}) {
	try {
	  const res = await fetch(url, {
		...options,
		headers: {
		  ...this.headers,
		  ...(options.headers || {})
		}
	  });
	  if (!res.ok) throw new Error(`HTTP ${res.status}`);
	  return await res.json();
	} catch (err) {
	  console.error(`❌ Error fetching ${url}:`, err);
	  return null;
	}
  }

  async postForm(url, formData) {
	const body = new URLSearchParams();
	Object.entries(formData).forEach(([key, value]) => {
	  if (Array.isArray(value)) {
		value.forEach(v => body.append(`${key}[]`, v));
	  } else {
		body.append(key, value);
	  }
	});

	try {
	  const res = await fetch(url, {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/x-www-form-urlencoded',
		  ...this.headers
		},
		body: body.toString()
	  });

	  const text = await res.text();
	  return { ok: res.ok, text };
	} catch (err) {
	  console.error(`❌ Error posting to ${url}:`, err);
	  return { ok: false, text: err.message };
	}
  }

  // =============================
  // Individual endpoint methods
  // =============================

  getLeases(search = '') {
	const acctID = encodeURIComponent(this.customer.cisproAcctID || '');
	const baseUrl = `/apps/portal/dev/leases/${acctID}`;
	const url = search ? `${baseUrl}?search=${encodeURIComponent(search)}` : baseUrl;
	return this.fetchJSON(url);
  }

  getOrders() {
	const acctID = encodeURIComponent(this.customer.cisproAcctID || '');
	return this.fetchJSON(`/apps/portal/dev/orders/${acctID}`);
  }

  getOrderItems(orderId) {
	return this.fetchJSON(`/apps/portal/dev/order-items/${encodeURIComponent(orderId)}`);
  }

  postRepairForm(data) {
	return this.postForm(`/apps/portal/dev/repair-request`, data);
  }

  // Serials (of those given) that already have an open repair request, or null if the check failed.
  async checkRepairSerials(serials) {
	const result = await this.postForm(`/apps/portal/dev/repair-request/check`, { serials: JSON.stringify(serials) });
	if (!result.ok) return null;
	try {
	  const open = JSON.parse(result.text).open;
	  return Array.isArray(open) ? open : null;
	} catch (e) {
	  return null;
	}
  }

  getRepairStatus(serial) {
	return this.fetchJSON(`/apps/portal/dev/repair-status/${encodeURIComponent(serial)}`);
  }
}

window.CustomerPortalAPI = CustomerPortalAPI;